<template>
  <div>
    <div class="row justify-content-center">
      <div class="col-xl-12">
        <div class="table-responsive" v-if="details.length !== 0">
          <a-form :form="form">
            <table class="table table-bordered table-sm">
              <thead>
                <tr>
                  <th>
                    <template>
                      <a-checkbox @change="toggleSelectAll($event)"/>
                    </template>
                  </th>
                  <th>Name</th>
                  <th>Section</th>
                  <th>Old Roll No.</th>
                  <th>New Roll No</th>
                  <th>Promote to Class</th>
                  <th>Promote to Section</th>
                  <th>Promotion Status</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(student, index) in this.details[0].students"
                  :key="index"
                >
                  <th>
                    <a-form-item>
                      <template>
                        <a-form-item>
                          <a-checkbox
                            v-decorator="[
                              `selected[${index}]`,
                              { valuePropName: 'checked', initialValue: false }
                            ]"
                            :disabled="student.is_promoted === 1"
                          >
                          </a-checkbox>
                        </a-form-item>
                      </template>
                    </a-form-item>
                  </th>
                  <!-- Id -->
                  <th style="display:none;">
                    <a-form-item>
                      <a-input
                        v-decorator="[
                              `studentId[${index}]`,
                              {
                                initialValue: getStudentId(student)
                              }
                            ]"
                        :hidden="true"
                      />
                    </a-form-item>
                  </th>
                  <!-- Student Code -->
                  <th style="display:none;">
                    <a-form-item>
                      <a-input
                        v-decorator="[
                              `studentCode[${index}]`,
                              {
                                initialValue: getStudentCode(student)
                              }
                            ]"
                        :hidden="true"
                      />
                    </a-form-item>
                  </th>
                  <!-- Name -->
                  <th
                    style="
                          width: 15.16%;
                          vertical-align: middle;
                          padding: 0.5rem;
                        "
                  >
                    <a-form-item>
                          <a-input
                            placeholder=""
                            v-decorator="[
                              `studentName[${index}]`,

                              {
                                initialValue: getStudent(student)
                              }
                            ]"
                            :disabled='true'
                            :min="0"
                            style="width: 100%; color: #1a252f"
                          />
                        </a-form-item>
                  </th>
                  <!-- old sec -->
                  <td
                    style="
                          width: 15.16%;
                          vertical-align: middle;
                          padding: 0.5rem;
                        "
                  >
                    <a-form-item>
                          <a-input
                            placeholder=""
                            v-decorator="[
                              `oldSection[${index}]`,

                              {
                                initialValue: getStudentSec(student)
                              }
                            ]"
                            :disabled='true'
                            :min="0"
                            style="width: 100%; color: #1a252f"
                          />
                        </a-form-item>
                  </td>
                  <!-- old roll no -->
                  <td style="
                          width: 14.16%;
                          vertical-align: middle;
                          padding: 0.5rem;
                        ">
                    <a-form-item>
                          <a-input
                            placeholder=""
                            v-decorator="[
                              `oldRollNo[${index}]`,

                              {
                                initialValue: getStudentRoll(student)
                              }
                            ]"
                            :disabled='true'
                            :min="0"
                            style="width: 100%; color: #1a252f"
                          />
                        </a-form-item>
                  </td>
                  <!-- New roll no -->
                  <td style="
                          width: 14.16%;
                          vertical-align: middle;
                          padding: 0.5rem;
                        ">
                    <a-form-item>
                      <a-input-number
                        placeholder="New Roll No."
                        v-decorator="[
                          `NewRollNo[${index}]`,
                          {
                            initialValue: null
                          }
                        ]"
                        :disabled="student.is_promoted === 1"
                        style="width: 100%; color: #1a252f"
                      />
                    </a-form-item>
                  </td>
                  <!-- Promote to Class -->
                  <td style="
                          width: 14.16%;
                          vertical-align: middle;
                          padding: 0.5rem;
                        ">
                    <a-form-item>
                      <!-- <a-spin :spinning="classSpinning"> -->
                        <a-select
                          v-decorator="[
                            `promoteToclass[${index}]`,
                            {
                              rules: [
                                {
                                  required: false,
                                  message: 'select class!!'
                                }
                              ],
                              initialValue: student.is_promoted === 1 ? student.promoted_class_id : details[0].next_class
                            }
                          ]"
                          :disabled="student.is_promoted === 1"
                          placeholder="Select class"
                          @change="handleClassSelect"
                          style="color: #1a252f"
                        >
                          <template v-for="classSection in details[0].promote_classs">
                            <a-select-option
                              :value="classSection.id"
                              :key="classSection.id"
                            >
                              {{ classSection.name }}
                            </a-select-option>
                          </template>
                        </a-select>
                      <!-- </a-spin> -->
                    </a-form-item>
                  </td>
                  <!-- Promote to Section -->
                  <td style="
                          width: 14.16%;
                          vertical-align: middle;
                          padding: 0.5rem;
                        ">
                    <a-form-item>
                      <!-- <a-spin :spinning="classSpinning"> -->
                        <a-select
                          v-decorator="[
                            `promoteTosection[${index}]`,
                            {
                              rules: [
                                {
                                  required: false,
                                  message: 'Select section!!'
                                }
                              ],
                              initialValue: student.is_promoted === 1 ? student.promoted_section_id : details[0].next_section
                            }
                          ]"
                          :disabled="student.is_promoted === 1"
                          placeholder="Select Section"
                          @change="handleSectionSelect"
                          style="color: #1a252f"
                        >
                          <template v-for="classSection in details[0].promote_sections">
                            <a-select-option
                              :value="classSection.id"
                              :key="classSection.id"
                            >
                              {{ classSection.name }}
                            </a-select-option>
                          </template>
                        </a-select>
                      <!-- </a-spin> -->
                    </a-form-item>
                  </td>
                  <!-- Promotion Status -->
                  <td style="
                          width: 15.16%;
                          vertical-align: middle;
                          padding: 0.5rem;
                        ">
                    <a-form-item>
                      <a-input
                        placeholder=""
                        v-decorator="[
                              `is_promoted[${index}]`,

                              {
                                initialValue: getPromotionStatus(student)
                              }
                            ]"
                        :disabled='true'
                        :min="0"
                        style="
                        color: #1a252f;
                        width: 100%;
                        "/>
                    </a-form-item>
                  </td>

                </tr>
                <!-- <tr>
                    <th>
                      <a-form-item>
                        <template>
                          <a-checkbox />
                        </template>
                      </a-form-item>
                    </th>
                    <th
                      style="
                          width: 16.16%;
                          vertical-align: middle;
                          padding: 0.5rem;
                        "
                    >
                      Jamuna Elangbam
                    </th>
                    <td
                      style="
                          width: 16.16%;
                          vertical-align: middle;
                          padding: 0.5rem;
                        "
                    >
                      Sec-A
                    </td>
                    <td style="width: 16.16%">
                      56
                    </td>
                    <td style="width: 16.16%">
                      <a-form-item>
                        <a-input-number
                          placeholder="New Roll No."
                          v-decorator="[
                            `oldRollNo[][]`,
                            {
                              initialValue: undefined
                            }
                          ]"
                          style="width: 100%"
                        />
                      </a-form-item>
                    </td>
                    <td style="width: 16.16%">
                      <a-form-item>
                        <a-dropdown>
                          <a-menu slot="overlay" @click="handleMenuClick">
                            <a-menu-item key="1">
                              <a-icon type="user" />1st menu item
                            </a-menu-item>
                            <a-menu-item key="2">
                              <a-icon type="user" />2nd menu item
                            </a-menu-item>
                            <a-menu-item key="3">
                              <a-icon type="user" />3rd item
                            </a-menu-item>
                          </a-menu>
                          <a-button style="margin-left: 8px">
                            select class.... <a-icon type="down" />
                          </a-button>
                        </a-dropdown>
                      </a-form-item>
                    </td>
                    <td style="width: 16.16%">
                      <a-form-item>
                        <a-dropdown>
                          <a-menu slot="overlay" @click="handleMenuClick">
                            <a-menu-item key="1">
                              <a-icon type="user" />1st menu item
                            </a-menu-item>
                            <a-menu-item key="2">
                              <a-icon type="user" />2nd menu item
                            </a-menu-item>
                            <a-menu-item key="3">
                              <a-icon type="user" />3rd item
                            </a-menu-item>
                          </a-menu>
                          <a-button style="margin-left: 8px">
                            select section.... <a-icon type="down" />
                          </a-button>
                        </a-dropdown>
                      </a-form-item>
                    </td>
                  </tr>
                  <tr>
                    <th>
                      <a-form-item>
                        <template>
                          <a-checkbox />
                        </template>
                      </a-form-item>
                    </th>
                    <th
                      style="
                          width: 16.16%;
                          vertical-align: middle;
                          padding: 0.5rem;
                        "
                    >
                      Lord Mahesh
                    </th>
                    <td
                      style="
                          width: 16.16%;
                          vertical-align: middle;
                          padding: 0.5rem;
                        "
                    >
                      Sec-A
                    </td>
                    <td style="width: 16.16%">
                      56
                    </td>
                    <td style="width: 16.16%">
                      <a-form-item>
                        <a-input-number
                          placeholder="New Roll No."
                          v-decorator="[
                            `oldRollNo[][]`,
                            {
                              initialValue: undefined
                            }
                          ]"
                          style="width: 100%"
                        />
                      </a-form-item>
                    </td>
                    <td style="width: 16.16%">
                      <a-form-item>
                        <a-dropdown>
                          <a-menu slot="overlay" @click="handleMenuClick">
                            <a-menu-item key="1">
                              <a-icon type="user" />1st menu item
                            </a-menu-item>
                            <a-menu-item key="2">
                              <a-icon type="user" />2nd menu item
                            </a-menu-item>
                            <a-menu-item key="3">
                              <a-icon type="user" />3rd item
                            </a-menu-item>
                          </a-menu>
                          <a-button style="margin-left: 8px">
                            select class.... <a-icon type="down" />
                          </a-button>
                        </a-dropdown>
                      </a-form-item>
                    </td>
                    <td style="width: 16.16%">
                      <a-form-item>
                        <a-dropdown>
                          <a-menu slot="overlay" @click="handleMenuClick">
                            <a-menu-item key="1">
                              <a-icon type="user" />1st menu item
                            </a-menu-item>
                            <a-menu-item key="2">
                              <a-icon type="user" />2nd menu item
                            </a-menu-item>
                            <a-menu-item key="3">
                              <a-icon type="user" />3rd item
                            </a-menu-item>
                          </a-menu>
                          <a-button style="margin-left: 8px">
                            select section.... <a-icon type="down" />
                          </a-button>
                        </a-dropdown>
                      </a-form-item>
                    </td>
                  </tr> -->
              </tbody>
            </table>
          </a-form>
        </div>
        <div class="row text-right" v-if="details.length !== 0">
          <div class="col-xl-12">
            <a-button type="primary" @click="handle_promotion">
              Promote selected students
            </a-button>
          </div>
        </div>
        <div class="col-md-12 mb-2 text-center" v-else>No data found...!</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['details', 'promote_to_class', 'promote_to_section'],
  data: function() {
    return {
      form: this.$form.createForm(this),
      loadingTable: false,
      visible: false,
      classSpinning: false,
      studentDetails: [],
      data: [],
      meta: {},
      current: 1,
      pageSize: 30,
      getData: [],
    }
  },
  methods: {
    toggleSelectAll(e) {
      for (let i = 0; i < this.details[0].students.length; i++) {
        if (e.target.checked) {
          this.form.setFieldsValue({ [`selected[${i}]`]: true })
        } else {
          this.form.setFieldsValue({ [`selected[${i}]`]: false })
        }
      }
    },
    handle_promotion() {
      this.form.validateFields((err, values) => {
        if (!err) {
          // console.log('formData', values)
          const formRequestPayload = this.getRequestPayload(values)
          this.$confirm({
            title: `Are you sure you want to promote the selected student?`,
            content: `Click on the OK button to promote the selected student!`,
            onOk: () => {
              this.$http.post('/api/promotion/promote_students', formRequestPayload)
                .then((resp) => {
                  this.$emit('created')
                  this.loading = false
                  this.visible = false
                  if (resp.status === 200) {
                    this.$notification['success']({
                      message: 'Student Promotion Successful',
                      description: `Promotion successful!`,
                    })
                  } else {
                    this.$notification['warning']({
                      message: 'Unknown Error',
                      description: `There appears to be an error while submitting data. Response from server: ${resp.status} ${resp.message}`,
                    })
                  }
                  this.form.resetFields()
                })
                .catch((err) => {
                  this.loading = false
                  this.$neoNotify.error(err)
                })
            },
            onCancel: () => {
              this.loading = false
            },
          })
        }
      })
    },
    getStudentId(student) {
      return student.student.id
    },
    getStudentCode(student) {
      return student.student_code
    },
    getStudent(details) {
      return details.student.first_name + ' ' + details.student.last_name
      // if (details.length !== 0) {
      //   if (details[0].students.length !== 0) {
      //     return details[0].students
      //   }
      // }
    },
    getPromotionStatus(details) {
      if (details.is_promoted === 1) {
        return 'Promoted'
      } else {
        return 'Not Promoted'
      }
    },
    getStudentSec(details) {
      return details.section.name
    },
    getStudentRoll(details) {
      return details.roll_no
    },
    handleClassSelect() {},
    handleSectionSelect() {},

    getRequestPayload(values) {
      let students = []
      let j = 0
      for (let i = 0; i < values.studentId.length; i++) {
        if (values.selected[i] === true) {
          students[j] = {
            id: values.studentId[i],
            new_roll_no: values.NewRollNo[i],
            student_code: values.studentCode[i],
            to_class_id: values.promoteToclass[i],
            to_section_id: values.promoteTosection[i],
          }
          j = j + 1
        }
      }
      return {
        'to_session_id': this.details[0].nextSession,
        'students': students,
      }
    },
    // getStudentDetails() {
    //   // this.loadingTable = true
    //   this.$http
    //     .get('/api/student', {
    //       params: {
    //         session_id: this.details[0].current_session,
    //         class_id: this.details[0].class_id,
    //         section_id: this.details[0].current_section,
    //         // limit: this.pageSize,
    //         // page: this.current,
    //       },
    //     })
    //     .then(({ data }) => {
    //       this.studentDetails = data.data
    //       console.log(this.studentDetails)
    //       // this.loadingTable = false
    //       // this.data = data.data
    //       // this.meta = data.meta
    //     })
    // },
    //     getSessions: function() {
    //       this.loading = true
    //       this.$http.get('/api/session', {
    //         params: {
    //           limit: this.pageSize,
    //           page: this.current,
    //         },
    //       }).then(({ data }) => {
    //         this.loading = false
    //         this.data = data.data
    //         this.meta = data.meta
    //       })
    //     },
    //     handleCreated: function() {
    //       this.getSessions()
    //     },
    //     handleUpdateTable: function() {
    //       this.getSessions()
    //     },
    //     onShowSizeChange(current, pageSize) {
    //       this.pageSize = pageSize
    //       this.current = current
    //       this.getSessions()
    //     },
    //     onChange(current) {
    //       this.current = current
    //       this.getSessions()
    //     },
  },
}
</script>
